import { render } from "./AppLabelPlaces.vue?vue&type=template&id=2da9ff2f&scoped=true&ts=true"
import script from "./AppLabelPlaces.vue?vue&type=script&lang=ts"
export * from "./AppLabelPlaces.vue?vue&type=script&lang=ts"

import "./AppLabelPlaces.vue?vue&type=style&index=0&id=2da9ff2f&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da9ff2f"]])

export default __exports__